import { OccupancyType, PricingStrategy, ProxyType } from 'graphql/gql-types';

import { z } from 'zod';

export const RatesFormSchema = z.object({
	pricingStrategy: z.nativeEnum(PricingStrategy),
	minRate: z
		.string()
		.refine((val) => Number.parseFloat(val) >= 0)
		.default('49.00'),
	maxRate: z
		.string()
		.refine((val) => Number.parseFloat(val) >= 0)
		.default('500.00'),
	derivedRateType: z.nativeEnum(OccupancyType),
	derivedRateOffsetSign: z.enum(['+', '-']),
	derivedRateOffset: z.string().refine((val) => Number.parseFloat(val) >= 0),
	proxy_type: z.nativeEnum(ProxyType),
	proxy_comp_id: z.coerce.number().default(0),
	proxy_offset_amt: z.string().refine((val) => !Number.isNaN(Number(val)), {
		message: 'Offset must be a valid number',
	}),
	use_proxy: z.boolean().default(false),
});

export type RatesFormValues = z.infer<typeof RatesFormSchema>;
